import React, { cloneElement } from "react";
import ReactDOM from "react-dom";
import { useTooltip, TooltipPopup } from "@reach/tooltip";
import "@reach/tooltip/styles.css";

interface TriangleTooltipProps {
  children: React.ReactElement;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

function TriangleTooltip({ children, label, ...rest }: TriangleTooltipProps) {
  // get the props from useTooltip
  const [trigger, tooltip] = useTooltip();

  // destructure off what we need to position the triangle
  const { isVisible, triggerRect } = tooltip;
  const offsetLeft = triggerRect
    ? triggerRect.left - 10 + triggerRect.width / 2
    : 0;
  const offsetTop = triggerRect ? triggerRect.bottom + window.scrollY : 0;

  return (
    <>
      {cloneElement(children, trigger)}

      {isVisible &&
        // the Triangle, we position it relative to the trigger, not the popup
        // so that collisions don't have a triangle pointing off to nowhere
        ReactDOM.createPortal(
          <div
            className="absolute w-0 h-0 z-10 border-gray-900"
            style={{
              left: offsetLeft,
              top: offsetTop,
              borderLeft: "10px solid transparent",
              borderRight: "10px solid transparent",
              borderBottomWidth: "10px",
              borderBottomStyle: "solid",
            }}
          />,

          document.querySelector("body") as Element,
        )}
      <TooltipPopup
        {...tooltip}
        {...rest}
        label={label}
        style={{
          background: "black",
          color: "white",
          border: "none",
          borderRadius: "3px",
          padding: "0.5em 1em",
        }}
        position={undefined}
      />
    </>
  );
}

export default TriangleTooltip;
